import axios from "axios";
import { getCookie } from "common/Cookie";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

export function WidgetSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [responseData, setResponseData] = useState(null);
  const [currency, setCurrency] = useState('');
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
        // Authorization 토큰 가져오기 (예: 로컬 스토리지에서)
  const token = getCookie('accessToken');
    async function confirm() {
      const requestData = {
        orderId: searchParams.get("orderId"),
        amount: searchParams.get("amount"),
        paymentKey: searchParams.get("paymentKey"),
      };

      const response = await fetch("/api/confirm/widget", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}` ,// Authorization 헤더 추가
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const json = await response.json();

      if (!response.ok) {
        throw { message: json.message, code: json.code };
      }

      return json;
    }

    confirm()
      .then((data) => {
        setResponseData(data);
      })
      .catch((error) => {
        navigate(`/fail?code=${error.code}&message=${error.message}`);
      });
  }, [searchParams]);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axios.get('https://ipapi.co/json/');
        setCountry(response.data.country);
      } catch (error) {
        console.error('Error fetching country:', error);
      }
    };
    fetchCountry();
  }, []);

  useEffect(() => {
    const isKorean = country === 'KR';
    setCurrency(!isKorean ? '₩' : '$');
  }, []);

  const goToManageContacts = () => {
    navigate('/manage-contacts');
  };

  const goToScheduleContacts = () => {
    navigate('/schedule-contact'); 
  };

  const amount = Number(searchParams.get("amount")).toLocaleString();

  return (
    <>
      <div className="box_section" style={{ width: "600px" }}>
        <img width="100px" src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png" />
        <h2>Payment Completed</h2>
        <div className="p-grid typography--p" style={{ marginTop: "50px" }}>
          <div className="p-gr id-col text--left">
            <b>Amount</b>
          </div>
          <div className="p-grid-col text--right" id="amount">
          {`${currency}${amount}`}
          </div>
        </div>
        <div className="p-grid typography--p" style={{ marginTop: "10px" }}>
          <div className="p-grid-col text--left">
            <b>Order Number</b>
          </div>
          <div className="p-grid-col text--right" id="orderId">
            {`${searchParams.get("orderId")}`}
          </div>
        </div>
        <div className="p-grid-col">
            <button className="button p-grid-col5" style={{ backgroundColor: "#e8f3ff", color: "#1b64da" }}onClick={goToScheduleContacts}>
              Schedule a Contact
            </button>
            <button className="button p-grid-col5" onClick={goToManageContacts}>Manage Contacts</button>
            
        </div>
      </div>
      {/* <div className="box_section" style={{ width: "600px", textAlign: "left" }}>
        <b>Response Data :</b>
        <div id="response" style={{ whiteSpace: "initial" }}>
          {responseData && <pre>{JSON.stringify(responseData, null, 4)}</pre>}
        </div>
      </div> */}
    </>
  );
}